import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-mass-messenger-entity-selector-form',
  templateUrl: './mass-messenger-entity-selector-form.component.html',
  styleUrls: ['./mass-messenger-entity-selector-form.component.scss']
})
export class MassMessengerEntitySelectorFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
